import { render, staticRenderFns } from "./ChampionshipMatchDetailsDrawer.vue?vue&type=template&id=79a985aa&scoped=true"
import script from "./ChampionshipMatchDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./ChampionshipMatchDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChampionshipMatchDetailsDrawer.vue?vue&type=style&index=0&id=79a985aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a985aa",
  null
  
)

export default component.exports